export interface CustomTheme {
  // Brand colors
  brandPrimary: string;    // Main brand/accent color
  brandSecondary: string;  // Secondary brand color
  
  // UI Colors
  buttonColor: string;     // Primary button color
  linkColor: string;       // Link color
  
  // Background Colors
  pageBackground: string;  // Main page background
  cardBackground: string;  // Card/component background
  
  // Text Colors
  textPrimary: string;    // Primary text color
  textSecondary: string;  // Secondary/muted text color
  
  // Border Colors
  borderColor: string;    // Border color for cards/inputs
}

export const defaultTheme: CustomTheme = {
  brandPrimary: '#0369a1',
  brandSecondary: '#1e293b',
  buttonColor: '#0369a1',
  linkColor: '#0369a1',
  pageBackground: '#ffffff',
  cardBackground: '#ffffff',
  textPrimary: '#1a1a1a',
  textSecondary: '#6b7280',
  borderColor: '#e5e7eb'
};